import React from 'react';
import { Typography, Chip } from '@mui/material';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Financial class template with color-coded chips
 */
export const FinancialClassTemplate: React.FC<{ financialClass: string | null | undefined }> = ({
  financialClass,
}) => {
  const classColors: Record<string, { backgroundColor: string; color: string }> = {
    Commercial: { backgroundColor: '#dcfce7', color: '#16a34a' },
    Medicare: { backgroundColor: '#dbeafe', color: '#2563eb' },
    Medicaid: { backgroundColor: '#fef3c7', color: '#d97706' },
    'Self Pay': { backgroundColor: '#f3f4f6', color: '#374151' },
  };

  const classColor = classColors[financialClass as string] || {
    backgroundColor: '#f3f4f6',
    color: '#374151',
  };

  return financialClass ? (
    <Chip label={financialClass} size="small" sx={classColor} />
  ) : (
    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
      -
    </Typography>
  );
};

// Template function for grid column
export const financialClassTemplate = (rowData: ContractView) => (
  <FinancialClassTemplate financialClass={rowData.financialClass} />
);

export default FinancialClassTemplate;
